import * as React from "react";
import { Link, Timestamp } from "components/common";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import ProviderName from "aiagent/components/ProviderName";
import WorkflowStatus from "./WorkflowStatus";
import AgentWorkflowRoutes from "../Routes";
export const WorkflowStatusCell = ({ workflow }) => {
  const { refetch } = useTableFetchContext();
  return /* @__PURE__ */ React.createElement(WorkflowStatus, { workflow, onSuccess: refetch });
};
const columnRenderers = {
  attributes: {
    title: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(Link, { to: AgentWorkflowRoutes.workflowDetails(workflow.id), onClick: (event) => event.stopPropagation() }, workflow.title),
      staticWidth: 260
    },
    description: {
      width: 2,
      minWidth: 320
    },
    disabled: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(WorkflowStatusCell, { workflow }),
      staticWidth: 130
    },
    provider: {
      renderCell: (provider) => /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider }),
      staticWidth: 120
    },
    model: {
      renderCell: (model) => /* @__PURE__ */ React.createElement(React.Fragment, null, model),
      staticWidth: 140
    },
    last_run_at: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: workflow.last_run_at }),
      staticWidth: 190
    }
  }
};
export default columnRenderers;
